import React, { FC } from 'react';
import isEmpty from 'lodash/isEmpty';
import { Typography } from '@material-ui/core';
import { Row } from 'components/UI/Row';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { i18n } from 'helpers/i18n';

interface Datum {
  text: string;
  title: string;
}

interface PreviewDataProps {
  data: Datum[];
}

const PreviewData: FC<PreviewDataProps> = ({ data }) => {
  const { t } = useTranslation();
  return !isEmpty(data) ? (
    <>
      {data.map((datum, key) => {
        if (isEmpty(datum.text)) {
          return <React.Fragment key={key} />;
        }

        // Some data need to be translated in a specific way.
        let text = '';
        switch (datum.title) {
          case 'created at':
            const date = moment(datum.text, "YYYY-MM-DD HH:mm:ss Z 'UTC'").locale(i18n.language);
            text = `${date.format('LL')}, ${date.format('LTS')}`;
            break;
          case 'batch type':
            text = t(`preview.${datum.text}`);
            break;
          case 'country':
            text = t(`country.${datum.text.toUpperCase()}`);
            break;
          default:
            text = datum.text;
            break;
        }

        return (
          <React.Fragment key={key}>
            <Row margin="32px 16px 0 16px">
              <Typography variant="h6">{t(`preview.${datum.title}`)}</Typography>
            </Row>
            <Row margin="0 16px 0 16px">
              <Typography>{text}</Typography>
            </Row>
          </React.Fragment>
        );
      })}
    </>
  ) : null;
};

export { PreviewData };
